import { createContext, Dispatch, SetStateAction } from 'react';
import {
  IErrorResponse,
  IChargeHistoryDetailsResponse,
} from '../models/responses/oms';

export type TCurrentLineItemsView = {
  chargeDetails: string;
  charge: IChargeHistoryDetailsResponse['charges'][number];
};

export interface IViewChargedDetailsContext {
  openChargedDetailsDrawer: boolean;
  setOpenChargedDetailsDrawer: Dispatch<SetStateAction<boolean>>;
  chargeHistoryData: IChargeHistoryDetailsResponse | undefined;
  chargeHistoryLoading: boolean;
  chargeHistoryError: IErrorResponse | undefined;
  currentLineItemsView: TCurrentLineItemsView | undefined;
  setCurrentLineItemsView: Dispatch<
    SetStateAction<TCurrentLineItemsView | undefined>
  >;
}

const defaultState: IViewChargedDetailsContext = {
  openChargedDetailsDrawer: false,
  setOpenChargedDetailsDrawer: () => null,
  chargeHistoryData: undefined,
  chargeHistoryLoading: false,
  chargeHistoryError: undefined,
  currentLineItemsView: undefined,
  setCurrentLineItemsView: () => null,
};

export const ViewChargedDetailsContext =
  createContext<IViewChargedDetailsContext>(defaultState);
